//TODO: should also add these to the block-sanity-web repo

//TODO: additionallly we shuold move Image, Footer, and possibly Tag into Components
//Question: should we make a differentiation between 'pages' and 'entities'?

export enum EntityType {
  LandingPage = 'landingPage',
  NewsLandingPage = 'news.landingPage',
  NewsPost = 'news.post',
  NewsTag = 'news.tag',
  NewsTopic = 'news.topic',
  NewsTopicPage = 'news.topicPage',
  Footer = 'global.footer',
  LoadingScreen = 'global.loadingScreen',
  Navigation = 'global.navigation',
  JobListingPage = 'careers.jobListingPage',
  MediaKitLandingPage = 'mediaKit.landingPage',
  LegalCookiePage = 'legal.cookiePage',
  LegalLandingPage = 'legal.landingPage',
  LegalLicensesPage = 'legal.licensesPage',
  LegalPage = 'legal.page',
  PageTree = 'page.pageTree',
  Page = 'page'
}

export enum ComponentType {
  Accordion = 'components.common.accordion',
  AccordionItem = 'components.common.accordionItem',
  Card = 'components.common.card',
  Text = 'components.common.text',
  TextDivider = 'components.common.textDivider',
  ShapeLink = 'components.common.shapeLink',
  ShapeLinkGroup = 'components.common.shapeLinkGroup',
  Link = 'components.common.link',
  LinkGroup = 'components.common.linkGroup',
  Button = 'components.common.button',
  GithubButtons = 'components.common.githubButtons',
  Carousel = 'components.common.imageCarousel',
  Image = 'components.common.image',
  Video = 'components.common.video',
  Media = 'components.common.media',
  Modal = 'components.common.modal',
  IconStack = 'components.common.iconStack',
  IconStackIcon = 'components.common.iconStackIcon',
  ModalText = 'components.common.modalText',
  Quote = 'components.common.quote',
  VanityNumber = 'components.common.vanityNumber',
  NewsCard = 'components.news.cardV2',
  NewsLatestPosts = 'components.news.latestPosts',
  NewsQuote = 'components.news.quote',
  NewsRunningLane = 'components.news.runningLane',
  NewsSection = 'components.news.sectionV2',
  Bar = 'components.charts.bar',
  BarGroup = 'components.charts.barGroup',
  Globe = 'components.charts.globe',
  Map = 'components.charts.map',
  Pie = 'components.charts.pie',
  StackedBar = 'components.charts.stackedBar',
  StackedBarGroup = 'components.charts.stackedBarGroup',
  Treemap = 'components.charts.treemap',
  DatawrapperChart = 'components.charts.datawrapperChart',
  PageGallery = 'components.page.gallery',
  PageHero = 'components.page.hero',
  PageSection = 'components.page.gridSection',
  PageFullWidthMedia = 'components.page.fullWidthMedia'
}

export enum MiscTypes {
  Document = 'misc.documents',
  ExternalContent = 'misc.externalContent'
}
